module.exports = __webpack_public_path__ + "img/bank-effect-switch-disabled.5ae28d74.svg";